import { useEffect, useState } from 'react';

// Utils
import { getSeasons } from '../../../../packages/services/basketball/common';
import { transformSeasonNames, transformToSeasonOptions } from '@sportal365/smp-widget-utils';

// Types
import { IBasketballSeasonsResponseV2, IProgramDataLabels, SDKOptions } from '../../../../packages/types';

interface IUseSeasonsArgs {
  dataSeason?: string;
  teamId?: string;
  competitionId?: string;
  sdkOptions: SDKOptions;
  withCombinedSeasons?: boolean;
  dataLabels?: IProgramDataLabels | null;
}

export const useSeasons = ({ dataSeason, teamId, competitionId, sdkOptions, withCombinedSeasons, dataLabels }: IUseSeasonsArgs) => {
  const [seasonId, setSeasonId] = useState<string | undefined>(dataSeason);
  const [seasons, setSeasons] = useState<{ name: string; id: string }[]>([]);

  useEffect(() => {
    if (competitionId || teamId) {
      getSeasons({ params: { competition_id: competitionId, team_id: teamId }, sdkOptions })
        ?.then(({ seasons }: IBasketballSeasonsResponseV2) => {
          setSeasons(transformSeasonNames(seasons ?? [], dataLabels, withCombinedSeasons));
        })
        .catch((error: unknown) => {
          console.error(error);
        });
    }
  }, [competitionId, teamId]);

  useEffect(() => {
    if (seasons && seasons?.length > 0 && !seasonId) {
      setSeasonId(seasons[0].id);
    }
  }, [seasonId, seasons]);

  const seasonOptions = transformToSeasonOptions(seasons);

  return {
    seasonId,
    setSeasonId,
    seasonOptions,
  };
};
